// extracted by mini-css-extract-plugin
export default {"mapWrapper":"Map_mapWrapper__Je0FF","mapText":"Map_mapText__U06-d","mapLocation":"Map_mapLocation__IJPnU","divider":"Map_divider__6vfmf"};